<template>
	<div>
		<h1 class="brief-title">襄阳人才创新创业超市简介</h1>
		<el-row type="flex" justify="space-around" align="middle" style="padding:20px;background-color: #FFFFFF;">
			<el-col :span="10">
				<el-image style="width: 100%;height:280px;" :src="require('../../static/brief_1.jpg')"
					fit="cover"></el-image>
			</el-col>
			<el-col :span="12">
				<el-divider content-position="left">
					<div class="name-group">
						<div class="name">运营机制</div>
						<div class="en_name">Operation mechanism</div>
					</div>
				</el-divider>
				<div class="remark">
					<p>襄阳人才创新创业超市坚持政府引导与市场化运营相结合，由市委人才办、市人社局、高新区党工委宏观指导，襄阳为兴投资管理有限公司投资建设、自主经营、自负盈亏。襄阳人才超市通过
						统筹政府资源、配置市场资源、调动社会资源，致力于为人才创新创业提供“全过程、全要素、全方位”服务，努力建设成重点服务襄阳市、辐射带动汉江流域的人才创新创业服务集成平台。</p>
				</div>
			</el-col>
		</el-row>
		<el-image style="width: 100%;height:400px;margin-top: 30px;" :src="require('../../static/brief_2.jpg')"
			fit="cover"></el-image>
		<el-row type="flex" align="middle" style="padding:40px;">
			<el-col :span="24">
				<el-divider content-position="left" class="no-background">
					<div class="name-group">
						<div class="name">发展概况</div>
						<div class="en_name">Development overview</div>
					</div>
				</el-divider>
				<div class="remark">
					<p>在省、市、区三级组织、人社部门的精心指导和大力扶持下，襄阳人才超市整合了创新链、产业链、资金链、政策链、人才链等五链资源，集聚了人才企业、服务机构、载体平台、金融创投、创业导师、惠企政策、双创活动、创新成果等八大要素，致力于为人才创新创业提供45项“全周期、全过程、全要素、全方位”服务。其中包含28项公益服务和17项收费服务，构建起完善的服务链条和良好的服务生态。
					</p>
					<p>襄阳人才超市依托市场化运作实现了可持续发展；牵头组建襄阳人才超市服务联盟，建立了“资源共享、优势互补、合作共赢”的人才服务体系，优化了人才发展环境、人才创新创业营商环境。2019年，人才超市运营国家科技领军人才创新创业襄阳基地，链接科技部人才中心3000多位科技领军人才的智力资源，助力襄阳高质量发展。
					</p>
					<p>襄阳人才超市现有场地面积1800㎡，自2017年1月11日正式运营以来，注重服务模式创新，着力优化人才双创生态，充分释放人才创新创业潜能，并组建人才超市服务联盟，建设科技领军人才创新创业襄阳基地，取得了显著成效。先后获得“国家中小企业公共服务示范平台”“国家级众创空间”“省级优秀人才超市”“湖北省人才创新服务中心”“湖北省中小企业公共服务严选服务机构”“省级服务型制造示范平台”“省级优秀人力资源服务诚信示范机构”“襄阳市人才工作先进单位”等荣誉。
					</p>
					<p>截至目前，累计服务人才企业46000多人次，累计公益服务25000多人次；线下聚集服务机构30家，线上合作服务机构200多家；对接人才双创载体平台60多个，成功推荐入驻企业800多家；聚集30多位省市知名创业导师，定期免费提供咨询辅导服务；成功举办200余场双创活动，省内外100多个单位前来学习考察。通过多措并举推动人才服务提质、产业研究破冰、成果转化赋能、产才融合增效，为襄阳都市圈高质量发展提供了人才保障和智力支撑。
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row type="flex" justify="space-around" align="middle" style="padding:20px;background-color: #FFFFFF;">
			<el-col :span="10">
				<el-image style="width: 100%;height:300px;" :src="require('../../static/brief_3.jpg')"
					fit="cover"></el-image>
			</el-col>
			<el-col :span="12">
				<el-divider content-position="left">
					<div class="name-group">
						<div class="name">发展规划</div>
						<div class="en_name">Development Planning</div>
					</div>
				</el-divider>
				<div class="remark">
					<p>襄阳人才超市致力于建成人才创新创业的“大本营”、企业发展壮大的“加油站”、双创服务机构的“集聚地”，不断完善服务功能，增强超市“续航”能力，努力打造在全省一流、在全国有影响的人才超市品牌，朝着“人才超市上市”的目标迈进。
					</p>
				</div>
			</el-col>
		</el-row>
		<el-row type="flex" justify="space-around" align="middle" style="padding:20px;background-color: #FFFFFF;">
			<el-col :span="12">
				<el-divider content-position="right">
					<div class="name-group">
						<div class="name">服务理念</div>
						<div class="en_name">Service Idea</div>
					</div>
				</el-divider>
				<div class="remark">
					<p>遵循“资源整合、要素集聚、服务超强、市场运作”的理念，统筹要素资源，搭建双创平台，通过“一窗口受理、一对一服务、一站式办结、一网式运行”，使服务对象“一看便知、一问便明、一查便懂、一办便成”。
					</p>
				</div>
			</el-col>
			<el-col :span="10">
				<el-image style="width: 100%;height:300px;" :src="require('../../static/brief_4.jpg')"
					fit="cover"></el-image>
			</el-col>
		</el-row>
		<el-row type="flex" align="middle" style="padding:40px;">
			<el-col :span="24">
				<el-divider content-position="left" class="no-background">
					<div class="name-group">
						<div class="name">服务对象</div>
						<div class="en_name">Service Object</div>
					</div>
				</el-divider>
				<div class="objs">
					<div class="obj">
						<el-image class="obj_img" :src="require('../../static/obj_2.png')" fit="cover"></el-image>
						<div class="obj_title">创新创业人才</div>
					</div>
					<div class="obj">
						<el-image class="obj_img" :src="require('../../static/obj_1.png')" fit="cover"></el-image>
						<div class="obj_title">创新创业企业</div>
					</div>
					<div class="obj">
						<el-image class="obj_img" :src="require('../../static/obj_5.png')" fit="cover"></el-image>
						<div class="obj_title">双创服务机构</div>
					</div>
					<div class="obj">
						<el-image class="obj_img" :src="require('../../static/obj_6.png')" fit="cover"></el-image>
						<div class="obj_title">双创载体平台</div>
					</div>
					<div class="obj">
						<el-image class="obj_img" :src="require('../../static/obj_3.png')" fit="cover"></el-image>
						<div class="obj_title">创业投资机构</div>
					</div>
					<div class="obj">
						<el-image class="obj_img" :src="require('../../static/obj_4.png')" fit="cover"></el-image>
						<div class="obj_title">券商金融机构</div>
					</div>
				</div>
			</el-col>
		</el-row>
		<!-- <el-row type="flex" justify="space-around" align="middle" style="padding:20px;background-color: #FFFFFF;">
		  <el-col :span="10">
			<el-image  style="width: 100%;height:300px;" :src="require('../../static/brief_5.jpg')"  fit="cover"></el-image>
		  </el-col>
		  <el-col :span="12">
			<el-divider content-position="left">
				<div class="name-group">
					<div class="name">服务方式</div>
					<div class="en_name">Development Planning</div>
				</div>
			</el-divider>
			
		  </el-col>
		</el-row> -->
		<!-- <el-row type="flex" align="middle" style="padding:40px;">
			<el-col :span="24">
				<el-divider content-position="left" class="no-background">
					<div class="name-group">
						<div class="name">功能区分</div>
						<div class="en_name">Functional differentiation</div>
					</div>
				</el-divider>
			</el-col>
		</el-row> -->
		<!-- 服务内容 -->
		<!-- <el-row type="flex" justify="space-around" align="middle" style="padding:20px;background-color: #FFFFFF;">
		  <el-col :span="12">
			<el-divider content-position="right">
				<div class="name-group">
					<div class="name">服务内容</div>
					<div class="en_name">Service Content</div>
				</div>
			</el-divider>
			<div class="remark"> -->

		<!-- <div class="li_one"><span class="dot"></span>创业辅导·项目论证</div>
					<div class="li_one"><span class="dot"></span>政策咨询·项目申报</div>
					<div class="li_one"><span class="dot"></span>管理咨询·企业信息化</div>
					<div class="li_one"><span class="dot"></span>股权融资·债权融资</div>
					<div class="li_one"><span class="dot"></span>人才培训·招聘猎头</div>
					<div class="li_one"><span class="dot"></span>宣传推广·营销策划</div>
				
					<div class="li_one"><span class="dot"></span>场地·政务·刻章</div>
					<div class="li_one"><span class="dot"></span>财税·审计·评估</div>
					<div class="li_one"><span class="dot"></span>商标·专利·高企</div>
					<div class="li_one"><span class="dot"></span>产业链对接服务</div>
					<div class="li_one"><span class="dot"></span>党建·人才社区服务</div> -->

		<!-- 	</div>
		  </el-col>
		  <el-col :span="10">
		  	<el-image  style="width: 100%;height:300px;" :src="require('../../static/brief_6.jpg')"  fit="cover"></el-image>
		  </el-col>
		</el-row> -->
		<!-- 服务制度 -->
		<el-row type="flex" justify="space-around" align="middle" style="padding:20px;background-color: #FFFFFF;">
			<el-col :span="10">
				<el-image style="width: 100%;height:300px;" :src="require('../../static/brief_7.jpg')"
					fit="cover"></el-image>
			</el-col>
			<el-col :span="12">
				<el-divider content-position="left">
					<div class="name-group">
						<div class="name">服务制度</div>
						<div class="en_name">Service System</div>
					</div>
				</el-divider>
				<div class="remark" style="padding-left: 40px;">
					<div style="font-size: 14px;line-height: 36px;color: #333333;">现场办结制：随到随办、特事特办、急事急办、高效快办</div>
					<div style="font-size: 14px;line-height: 36px;color: #333333;">首问负责制：第一受理、责任不推、有问而来、满意而归</div>
					<div style="font-size: 14px;line-height: 36px;color: #333333;">全程代办制：根据需求、委托代办、事后跟踪、全程服务</div>
					<div style="font-size: 14px;line-height: 36px;color: #333333;">限时办理制：能减则减、能放则放、能快则快、能优则优</div>
					<div style="font-size: 14px;line-height: 36px;color: #333333;">预约服务制：有约必应、有疑必释、记录详细、快捷便利</div>
					<div style="font-size: 14px;line-height: 36px;color: #333333;">考评激励制：专业精湛、服务规范、热情周到、服务高效</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'brief-introduction',
		data() {
			return {};
		},
		methods: {}
	};
</script>

<style lang="scss" scoped>
	.brief-title {
		text-align: center;
		font-size: 48px;
		letter-spacing: 5px;
		color: #4798dd;
		font-weight: bold;
		margin-bottom: 50px;
	}

	.name-group {
		display: flex;
		flex-direction: column;

		.name {
			font-size: 40px;
			color: #4798dd;
			font-weight: bold;
		}

		.en_name {
			line-height: 19px;
			font-size: 10px;
			color: #999999;
		}
	}

	.remark {
		margin-top: 50px;

	}

	p {
		text-indent: 30px;
		font-size: 16px;
		line-height: 30px;
		color: #333333;
		text-align: justify;
	}

	.no-background .el-divider__text {
		background-color: #F5F5F5;
	}

	.li_one {
		flex: 0 0 50%;
		flex-wrap: wrap;
		font-size: 16px;
		line-height: 36px;
		color: #666666;
		display: flex;
		align-items: center;

		.dot {
			width: 6px;
			height: 6px;
			border-radius: 3px;
			background-color: #0083cb;
		}
	}

	/*服务对象**/
	.objs {
		display: flex;
		flex-direction: row;
		justify-content: center;
		margin-top: 60px;
	}

	.obj {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin: 10px;
		width: 190px;
		height: 160px;
		border-radius: 95px;
		border: 1px solid #4798DD;

		.obj_img {
			width: 60px;
			height: 60px;
			background-repeat: no-repeat;
			background-position: center center;
			background-size: auto;
		}

		.obj_title {
			font-size: 17px;
			font-weight: bold;
			color: #4A99DD;
			text-align: center;
			margin-top: 18px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/brief-introduction.vue